export default __webpack_public_path__ + "static/media/icon-question-mark-inverted.09cfacc7.svg";